export default "__VITE_ASSET__Dsacn6IS__"